<mat-button-toggle-group #toggleGroup="matButtonToggleGroup" class="compact-toggle-group" [multiple]="true">

  <!-- Estados -->
  <mat-button-toggle #statusToggle="matButtonToggle" *ngIf="showStatus?.length"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="statusMenuFilter" value="estados"
    [checked]="selectedStatuses?.length > 0" (click)="resetIfEmpty(statusToggle, selectedStatuses?.length)">
    <span class="text-xs font-medium state-label uppercase">Estados</span>
  </mat-button-toggle>

  <!-- Modo Arbol -->
  <mat-button-toggle #statusToggle="matButtonToggle" *ngIf="showTreeMode"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="treeModeMenuFilter"
    value="estados-modetree" [checked]="!!treeModes">
    <span class="text-xs font-medium state-label uppercase">Modo Árbol</span>
  </mat-button-toggle>

  <!-- Tree mode unit -->
  <mat-button-toggle #treeUnitToggle="matButtonToggle" *ngIf="showTreeModeUnit && typeFilter === 'master'"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="treeModeMenuFilterUnit"
    value="estados-modetree-unit" [checked]="!!modeTreeUnit">
    <span class="text-xs font-medium state-label uppercase">Modo Árbol</span>
  </mat-button-toggle>

  <!-- Modo Arbol -->
  <mat-button-toggle #treeMonitorToggle="matButtonToggle" *ngIf="showTreeModeMonitor"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="treeModeMenuFilterMonitor"
    value="estados-modetree-monitor" [checked]="!!modeTreeMonitor">
    <span class="text-xs font-medium state-label uppercase">Modo Árbol</span>
  </mat-button-toggle>

  <!--Estados de viaje-->
  <mat-button-toggle #statusTravelToggle="matButtonToggle" *ngIf="showTripStatuses?.length"
    class="compact-toggle h-8 min-h-8 rounded-full px-1" [matMenuTriggerFor]="statusTravelMenuFilter"
    value="estados-travel" [checked]="selectedTripStatuses?.length > 0"
    (click)="resetIfEmpty(statusTravelToggle, selectedTripStatuses?.length)">
    <span class="text-xs font-medium state-label uppercase">Estados Viaje</span>
  </mat-button-toggle>

  <!--Función de ruta -->
  <!-- Función de Ruta -->
  <mat-button-toggle #routeFunctionToggle="matButtonToggle" *ngIf="showRouteFunction"
    class="compact-toggle h-8 min-h-8 rounded-full px-1" [matMenuTriggerFor]="routeFunctionMenuFilter"
    value="funcion-ruta" [checked]="selectedRouteFunction?.length > 0"
    (click)="resetIfEmpty(routeFunctionToggle, selectedRouteFunction?.length)">
    <span class="text-xs font-medium state-label uppercase">Función de Ruta</span>
  </mat-button-toggle>

  <!-- Estados Nuevos Prospectos -->
  <mat-button-toggle #statusNewBPToggle="matButtonToggle" *ngIf="showStatusNewBP?.length"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="statusMenuFilterNewBP"
    value="estados-newbp" [checked]="selectedStatusNewBP?.length > 0"
    (click)="resetIfEmpty(statusNewBPToggle, selectedStatusNewBP?.length)">
    <span class="text-xs font-medium state-label uppercase">Estados</span>
  </mat-button-toggle>

  <!-- Estados ERP -->
  <mat-button-toggle #statusERPToggle="matButtonToggle" *ngIf="showERPStatus?.length"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="statusERPMenuFilter" value="estados-erp"
    [checked]="selectedERPStatuses?.length > 0" (click)="resetIfEmpty(statusERPToggle, selectedERPStatuses?.length)">
    <span class="text-xs font-medium state-label uppercase">Estados ERP</span>
  </mat-button-toggle>

  <!-- Cliente -->
  <mat-button-toggle #customerToggle="matButtonToggle" *ngIf="showCustomerType?.length"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="customerMenuFilter" value="customer"
    [checked]="selectedCustomerType?.length > 0" (click)="resetIfEmpty(customerToggle, selectedCustomerType?.length)">
    <span class="text-xs font-medium state-label uppercase">Cliente</span>
  </mat-button-toggle>

  <!-- Bank Type -->
  <mat-button-toggle #bankTypeToggle="matButtonToggle" *ngIf="showStatusBankType"
    class="compact-toggle h-8 min-h-8 rounded-full px-3" [matMenuTriggerFor]="bankTypeMenuFilter"
    value="estados-bankType" [checked]="selectedStatusesBankType?.length > 0"
    (click)="resetIfEmpty(bankTypeToggle, selectedStatusesBankType?.length)">
    <span class="text-xs font-medium state-label uppercase">Tipo</span>
  </mat-button-toggle>

  <!-- Tipo de Solicitud de Credito -->
  <mat-button-toggle
    #requestCreditToggle="matButtonToggle"
    *ngIf="showRequestCredit"
    class="compact-toggle h-8 min-h-8 rounded-full px-3"
    [matMenuTriggerFor]="requestCreditMenuFilter"
    value="estados-requestCredit"
    [checked]="selectedStatusRequestCredit?.length > 0"
    (click)="resetIfEmpty(requestCreditToggle, selectedStatusRequestCredit?.length)">
    <span class="text-xs font-medium state-label uppercase">Tipo</span>
  </mat-button-toggle>

</mat-button-toggle-group>

<mat-menu #statusMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of statusOptions"
    (click)="toggleSelection(option.value); $event.stopPropagation()">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <mat-pseudo-checkbox [state]="isSelected(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{option.label}}</span>
      </div>
      <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
    </div>
  </button>
  <mat-divider *ngIf="selectedStatuses?.length > 0"></mat-divider>
  <button mat-menu-item *ngIf="selectedStatuses?.length > 0" (click)="clearStatuses(); $event.stopPropagation()"
    class="text-red-600">
    <div class="flex items-center w-full">
      <mat-icon class="mr-2" svgIcon="heroicons_outline:x-circle"></mat-icon>
      <span class="text-xs uppercase font-medium">Limpiar</span>
    </div>
  </button>
</mat-menu>


<mat-menu #treeModeMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of treeModesList"
    (click)="toggleSelectionTreeMode(option.value); $event.stopPropagation()">
    <div class="flex items-center">
      <mat-pseudo-checkbox [state]="isSelectedTreeMode(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
        appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
      </mat-pseudo-checkbox>
      <span class="text-xs uppercase font-medium">{{ option.label }}</span>
    </div>
  </button>
</mat-menu>

<mat-menu #treeModeMenuFilterMonitor="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of treeModesListMonitor"
    (click)="toggleSelectionTreeModeMonitor(option.value); $event.stopPropagation()">
    <div class="flex items-center">
      <mat-pseudo-checkbox [state]="isSelectedTreeModeMonitor(option.value) ? 'checked' : 'unchecked'"
        aria-hidden="true" appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
      </mat-pseudo-checkbox>
      <span class="text-xs uppercase font-medium">{{ option.label }}</span>
    </div>
  </button>
</mat-menu>


<mat-menu #treeModeMenuFilterUnit="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of treeModestListUnit"
    (click)="toggleSelectionTreeModeUnit(option.value); $event.stopPropagation()">
    <div class="flex items-center">
      <mat-pseudo-checkbox [state]="isSelectedTreeModeUnit(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
        appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
      </mat-pseudo-checkbox>
      <span class="text-xs uppercase font-medium">{{ option.label }}</span>
    </div>
  </button>
</mat-menu>

<mat-menu #statusMenuFilterNewBP="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of statusNewBP"
    (click)="toggleSelectionNewBP(option.value); $event.stopPropagation()">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <mat-pseudo-checkbox [state]="isNewBPSelected(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{option.label}}</span>
      </div>
      <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
    </div>
  </button>
</mat-menu>

<mat-menu #statusERPMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of erpStatusOptions"
    (click)="toggleERPSelection(option.value); $event.stopPropagation()">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <mat-pseudo-checkbox [state]="isERPSelected(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{option.label}}</span>
      </div>
      <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
    </div>
  </button>
  <mat-divider *ngIf="selectedERPStatuses?.length > 0"></mat-divider>
  <button mat-menu-item *ngIf="selectedERPStatuses?.length > 0" (click)="clearERPStatuses(); $event.stopPropagation()"
    class="text-red-600">
    <div class="flex items-center w-full">
      <mat-icon class="mr-2" svgIcon="heroicons_outline:x-circle"></mat-icon>
      <span class="text-xs uppercase font-medium">Limpiar</span>
    </div>
  </button>
</mat-menu>

<mat-menu #customerMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of erpCustomerOptions"
    (click)="toggleCustomerSelection(option.value); $event.stopPropagation()">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <mat-pseudo-checkbox [state]="isCustomerSelected(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{option.label}}</span>
      </div>
      <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
    </div>
  </button>
  <mat-divider *ngIf="selectedCustomerType?.length > 0"></mat-divider>
  <button mat-menu-item *ngIf="selectedCustomerType?.length > 0"
    (click)="clearCustomerTypes(); $event.stopPropagation()" class="text-red-600">
    <div class="flex items-center w-full">
      <mat-icon class="mr-2" svgIcon="heroicons_outline:x-circle"></mat-icon>
      <span class="text-xs uppercase font-medium">Limpiar</span>
    </div>
  </button>
</mat-menu>

<mat-menu #bankTypeMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
    <button mat-menu-item *ngFor="let option of statusBankType"
        (click)="toggleBankTypeSelection(option.value); $event.stopPropagation()">
        <div class="flex justify-between w-full">
            <div class="flex items-center">
                <mat-pseudo-checkbox [state]="isBankTypeSelected(option.value) ? 'checked' : 'unchecked'"
                    aria-hidden="true" appearance="minimal"
                    class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
                </mat-pseudo-checkbox>
                <span class="text-xs uppercase font-medium">{{option.label}}</span>
            </div>
            <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
        </div>
    </button>
</mat-menu>

<mat-menu #requestCreditMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
    <button mat-menu-item *ngFor="let option of requestCreditType"
        (click)="toggleRequestCreditSelection(option.value); $event.stopPropagation()">
        <div class="flex justify-between w-full">
            <div class="flex items-center">
                <mat-pseudo-checkbox [state]="isRequestCreditSelected(option.value) ? 'checked' : 'unchecked'"
                    aria-hidden="true" appearance="minimal"
                    class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
                </mat-pseudo-checkbox>
                <span class="text-xs uppercase font-medium">{{option.label}}</span>
            </div>
            <mat-icon class="ml-2" [svgIcon]="option.icon" [style.color]="option.color"></mat-icon>
        </div>
    </button>
</mat-menu>
<!-- Menú para Estados de Viaje -->
<mat-menu #statusTravelMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of tripStatusOptions"
    (click)="toggleTripStatusSelection(option.value); $event.stopPropagation()">
    <div class="flex justify-between w-full items-center">
      <div class="flex items-center mt-1">
        <mat-pseudo-checkbox [state]="isTripStatusSelected(option.value) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{getTripStatusConfig(option.value)?.shortLabel}}</span>
      </div>
      <app-trip-status-icon class="ml-2" [statusTripId]="option.value" size="lg"></app-trip-status-icon>
    </div>
  </button>
</mat-menu>

<!-- Menú para Función de Ruta -->
<mat-menu #routeFunctionMenuFilter="matMenu" (click)="$event.stopPropagation()" class="rounded-2xl">
  <button mat-menu-item *ngFor="let option of routeFunctionOptions"
    (click)="toggleRouteFunctionSelection(option.name); $event.stopPropagation()">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <mat-pseudo-checkbox [state]="isRouteFunctionSelected(option.name) ? 'checked' : 'unchecked'" aria-hidden="true"
          appearance="minimal" class="mat-pseudo-checkbox mat-pseudo-checkbox-minimal mr-2">
        </mat-pseudo-checkbox>
        <span class="text-xs uppercase font-medium">{{option.name}}</span>
      </div>
    </div>
  </button>
</mat-menu>